import React from 'react';
import { HLSPlayer, useCarouselContext } from '@doer/frontend-components/carrusel';
import { VideoItem } from '../constants/videos';

interface VideoCardProps {
  video: VideoItem;
  onOpenReel: () => void;
}

export const VideoCard: React.FC<VideoCardProps> = ({ video, onOpenReel }) => {
  const [isHovered, setIsHovered] = React.useState(false);
  const { isModalOpen } = useCarouselContext();
  // Pause grid previews when the swipe modal is open — only one <video> per URL must play at a time
  const shouldPlay = isHovered && !isModalOpen;

  return (
    <div
      onClick={onOpenReel}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        position: 'relative',
        borderRadius: 12,
        overflow: 'hidden',
        cursor: 'pointer',
        boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
        background: '#000',
        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
      }}
      onMouseOver={e => { (e.currentTarget as HTMLDivElement).style.transform = 'scale(1.02)'; }}
      onMouseOut={e => { (e.currentTarget as HTMLDivElement).style.transform = 'scale(1)'; }}
    >
      <div style={{ position: 'relative', paddingTop: '177.78%' }}>
        {video.poster && (
          <img
            src={video.poster}
            alt={video.title}
            style={{
              position: 'absolute',
              top: 0, left: 0,
              width: '100%', height: '100%',
              objectFit: 'cover',
              opacity: shouldPlay ? 0 : 1,
              transition: 'opacity 0.2s ease',
            }}
          />
        )}
        {!isModalOpen && (
          <HLSPlayer
            src={isHovered ? (video.src_preview ?? video.b2_url) : undefined}
            playing={isHovered}
            muted
            loop
            playsInline
            preload='none'
            style={{
              position: 'absolute',
              top: 0, left: 0,
              width: '100%', height: '100%',
              objectFit: 'cover',
              opacity: isHovered ? 1 : 0,
              transition: 'opacity 0.2s ease',
            }}
          />
        )}
      </div>

      {video.title && (
        <div style={{
          position: 'absolute',
          bottom: 0, left: 0, right: 0,
          padding: '24px 10px 10px',
          background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)',
          color: 'white',
          fontSize: 12,
          fontWeight: 500,
          pointerEvents: 'none',
        }}>
          {video.title}
        </div>
      )}
    </div>
  );
};
